// Contains custom js for the theme - Vaishnavi Bobjee
(function ($) {
  $(function() {
    $('.open-modal').click(function() {
      var modal = $(this).data('modal');
      $('#' + modal).css('display', 'block');
    });
    
    $(".popup .close").click(function() {
      var parent = $(this).parents(".video-overlay").find('iframe');
      parent.attr('src', parent.attr('src'));
      $('.video-overlay').css('display', 'none');
    });

    // Custom Rink select function for variant sizes     
    if ($("form.js-product-form .bold_options").length) {
      let updatedRinkTotal = null;
      let isUSD = window.BOLD.common.Shopify.cart ? window.BOLD.common.Shopify.cart.currency === "USD" : true;

      // This handler also disables Length options that are not applicable when a width is selected and vice versa for Custom Rink Product
      $('body').on('change', 'select[name="properties[Length]"], select[name="properties[Width]"]', function() {
        var length = $('select[name="properties[Length]"]').val();
        var width = $('select[name="properties[Width]"]').val();
        var combinedPattern = width + ' x ' + length;
        let isWidth = $(this).attr("name").toLowerCase().includes("width");

        if (isWidth) {
          let widthUnit = width.replace("'","");
          $('select[name="properties[Length]"] option').attr("disabled", false);

          $('select[name="properties[Length]"] option').each(function() {
            let lengthUnit = $(this).val().replace("'","");
            if (lengthUnit < widthUnit) {
              $(this).attr("disabled", true);
              return true;
            }
            return false
          })
        } else {
          let lengthUnit = length.replace("'","");
          $('select[name="properties[Width]"] option').attr("disabled", false);

          $('select[name="properties[Width]"] option').each(function() {
            let widthUnit = $(this).val().replace("'","");
            if (lengthUnit < widthUnit) {
              $(this).attr("disabled", true);
            }
          })
        }
        
        if (length && width) {
          $('input[name="properties[Width/Length]"]').each(function() {
            var value = $(this).val();
            if (value.indexOf(combinedPattern) !== -1) {
              $(this).click();
              return false;
            }
          });
        }
      });

      if (window.BOLD && BOLD.common && BOLD.common.eventEmitter){
        // Do not translate the NHL Team names - Google Translate App
        BOLD.common.eventEmitter.on('BOLD_OPTIONS_options_loaded', function(data) {
          $('select[name="properties[NHL Team Logo Decals]"] option:not(:first-child)').addClass('notranslate');
        })

        BOLD.common.eventEmitter.on('BOLD_OPTIONS_option_changed', function(a) {
          console.log('Bold Options option change')
          console.log(a);
          if (a.data.is_priced_option && !isUSD) {
            let productID = $("[name='properties[_boldProductIds]']").val();
            let variantID = $("[name='properties[_boldVariantIds]']").val();
            let products = window.BOLD?.common.Shopify.productsjs;

            for (const pdt in products) {
              if (products[pdt].id == parseInt(productID)) {
                let variantData = products[pdt].variants.find(v => v.id == variantID);

                if (variantData) {
                  $("[name='properties[_boldVariantPrices]']").val(variantData.price);
                  updatedRinkTotal = variantData.price;
                  let basePrice = a.data.option_product.priceHandler.productPrice;
                  $(".bold_option_price_display").text(window.BOLD.common.Shopify.formatMoney(variantData.price + basePrice, theme.money_format));
                  break;
                }
              }
            }          
          }
        });

        // Update Affirm montly pricing when product price changes (Custom rink)
        BOLD.common.eventEmitter.on('BOLD_OPTIONS_total_changed', function(a){
          let customPrice = a.data.option_product.priceHandler.total +  a.data.option_product.priceHandler.productPrice;
          $('.affirm-as-low-as').attr('data-amount',customPrice);
          affirm.ui.refresh();

          if (updatedRinkTotal && !isUSD) {
            let basePrice = a.data.option_product.priceHandler.productPrice;
            $(".bold_option_price_display").text(window.BOLD.common.Shopify.formatMoney(updatedRinkTotal + basePrice, theme.money_format));
            updatedRinkTotal = null;
          }
        });

        BOLD.common.eventEmitter.on('BOLD_EVENTQUEUE_after_run', function(a) {
          var $errorField = $('.bold_option_error');
          if ($errorField.length) {
              var headerHeight = $('#pageheader').height();
              var elementPosition = $errorField.offset().top - headerHeight;
              $('html, body').animate({
                  scrollTop: elementPosition
              }, 1000);
          }
        });
      }
    }

    // Bold Options on cart page removes the currency code for cart total price. If the cart currency is in CAD, the price is still displayed as $xxx.
    // This code updates the cart total with the currency format
    if ($(".bold_cart_total + .theme-money").length) {
      $(".bold_cart_total + .theme-money").text(window.BOLD.common.Shopify.formatMoney(window.BOLD.common.cartDoctor.cart.total_price, theme.money_format));
    }

    


  })
})(theme.jQuery); 